import { defineStore } from 'pinia';

const loginUserStore = defineStore({
  // ストア名
  id: 'loginUser',
  // 初期状態を返す関数
  state: () => ({
    // ユーザーID
    user_id: '',
    // ユーザー名
    user_name: '',
    // 権限
    role: '',
    // メールアドレス
    mail_address: '',
    // カートID
    cart_id: '',
    // パンチアウトタイプ
    po_type: '',
  }),
  getters: {},
  actions: {
    setLoginUser(loginUser) {
      this.user_id = loginUser.user_id;
      this.user_name = loginUser.user_name;
      this.role = loginUser.role;
      this.mail_address = loginUser.mail_address;
      this.cart_id = loginUser.cart_id;
      this.po_type = loginUser.po_type;
    },
  },
});

export default loginUserStore;
